var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiagrama({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.968,
    height: 25.162,
    viewBox: "0 0 20.968 25.162",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "diagram-2-fill",
    d: "M9.291,5.145A3.145,3.145,0,0,1,12.436,2h2.1a3.145,3.145,0,0,1,3.145,3.145v2.1a3.145,3.145,0,0,1-3.145,3.145v2.1h5.242a1.048,1.048,0,0,1,1.048,1.048v2.1a1.048,1.048,0,0,1-2.1,0V14.581H8.242v1.048a1.048,1.048,0,0,1-2.1,0v-2.1a1.048,1.048,0,0,1,1.048-1.048h5.242v-2.1A3.145,3.145,0,0,1,9.291,7.242ZM3,21.92a3.145,3.145,0,0,1,3.145-3.145h2.1a3.145,3.145,0,0,1,3.145,3.145v2.1a3.145,3.145,0,0,1-3.145,3.145h-2.1A3.145,3.145,0,0,1,3,24.017Zm12.581,0a3.145,3.145,0,0,1,3.145-3.145h2.1a3.145,3.145,0,0,1,3.145,3.145v2.1a3.145,3.145,0,0,1-3.145,3.145h-2.1a3.145,3.145,0,0,1-3.145-3.145Z",
    transform: "translate(-3 -2)",
    fill: "#003082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagrama);
export default __webpack_public_path__ + "static/media/diagrama.079915a2bf2ce1cab7f8d8f69e0aeebf.svg";
export { ForwardRef as ReactComponent };